import React from 'react';
import { Link } from 'react-router-dom';
import { buttonClassNames } from './buttonClassNames';

const isExternalHref = (to) =>
  typeof to === 'string' && /^(https?:|mailto:|tel:)/.test(to);

const LinkButton = ({
  to,
  children,
  variant = 'default',
  disabled = false,
  className = '',
  target,
  rel,
  onClick,
  id,
  'aria-label': ariaLabel,
}) => {
  const classes = buttonClassNames({ variant, disabled, className });

  if (disabled) {
    return (
      <span
        role="link"
        aria-disabled="true"
        aria-label={ariaLabel}
        id={id}
        className={classes}
        tabIndex={-1}
        onClick={(event) => event.preventDefault()}
      >
        {children}
      </span>
    );
  }

  if (isExternalHref(to) || target === '_blank') {
    const safeRel = rel || (target === '_blank' ? 'noopener noreferrer' : undefined);
    return (
      <a
        href={to}
        className={classes}
        target={target}
        rel={safeRel}
        onClick={onClick}
        aria-label={ariaLabel}
        id={id}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      to={to}
      className={classes}
      onClick={onClick}
      aria-label={ariaLabel}
      id={id}
    >
      {children}
    </Link>
  );
};

export default LinkButton;
